/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_3Inputs */

const en_flow_order_3 = /** @type {(inputs: Flow_Order_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buyer accepts the confirmation in Frontrow.`)
};

/**
* | output |
* | --- |
* | "The buyer accepts the confirmation in Frontrow." |
*
* @param {Flow_Order_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_3 = /** @type {((inputs?: Flow_Order_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_3(inputs)
});